var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTokenFlame = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.125 24.4444L30.5 27.2222M30.5 27.2222L24.875 24.4444M30.5 27.2222V34.1667M53 16.1111L47.375 18.8889M53 16.1111L47.375 13.3333M53 16.1111V23.0556M36.125 7.77778L30.5 5L24.875 7.77778M8 16.1111L13.625 13.3333M8 16.1111L13.625 18.8889M8 16.1111V23.0556M30.5 55L24.875 52.2222M30.5 55L36.125 52.2222M30.5 55V48.0556M13.625 46.6667L8 43.8889V36.9444M47.375 46.6667L53 43.8889V36.9444",
    stroke: "url(#paint0_linear_10326_921)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.125 24.4444L30.5 27.2222M30.5 27.2222L24.875 24.4444M30.5 27.2222V34.1667M53 16.1111L47.375 18.8889M53 16.1111L47.375 13.3333M53 16.1111V23.0556M36.125 7.77778L30.5 5L24.875 7.77778M8 16.1111L13.625 13.3333M8 16.1111L13.625 18.8889M8 16.1111V23.0556M30.5 55L24.875 52.2222M30.5 55L36.125 52.2222M30.5 55V48.0556M13.625 46.6667L8 43.8889V36.9444M47.375 46.6667L53 43.8889V36.9444",
    stroke: "url(#paint1_linear_10326_921)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10326_921",
    x1: 30.5,
    y1: 5,
    x2: 30.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10326_921",
    x1: 30.5,
    y1: 5,
    x2: 30.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF14EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC416"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTokenFlame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/token-flame.65c30f0681d591e81fd0ab0eb2c453e8.svg";